import React from 'react';

/**
 * Badge — status / category label.
 *
 * Props:
 *   tone: 'neutral' | 'brand' | 'success' | 'warning' | 'danger' | 'info'
 *   dot:  boolean — show a leading status dot
 */
const Badge = ({ tone = 'neutral', dot = false, className = '', children, ...rest }) => (
  <span className={`ps-badge ps-badge--${tone} ${className}`.trim()} {...rest}>
    {dot && <span className="ps-badge__dot" aria-hidden="true" />}
    {children}
  </span>
);

export default Badge;
